export default __webpack_public_path__ + "static/media/21-1_star.fba30b72.svg";